/* --- Styles --- */
import "./css-shell/main.css";
import "./page-styles/webfonts.css";
import "./page-styles/article.css";
import "./page-styles/page-header.css";
import "./page-styles/page-footer.css";
import "./page-styles/main-navigation.css";
import "./page-styles/news.css";
import "./page-styles/references.css";
import "./page-styles/social-media.css";
import "./page-styles/awards.css";
import "./page-styles/customer-list.css";
import "./page-styles/team.css";
import "./page-styles/team.css";
import "./page-styles/bouncy-arrow.css";
import "./page-styles/goto-buttons.css";
import "./page-styles/category-list.css";
import "./page-styles/sort-list.css";
import "./page-styles/cta.css";
import "./page-styles/form.css";
import "./page-styles/simple-hero.css";

/* --- Application --- */
import Vue from "vue";
import VueRouter from "vue-router";
import Vuelidate from 'vuelidate';
import taggr from "./devtools/taggr";
import debounce from "lodash-es/debounce";

import Fixie from "./components/fixie.vue";
import LazyMedia from "./components/lazy-media.vue";
import ReferenceOverview from "./components/scripts/reference-overview";
import TeamDetail from "./components/teamDetail.vue";
import Carousel from "./components/carousel";
import GoogleMap from "./components/google-map.vue";
import scrollIntoViewport from "./helpers/scroll-into-viewport";
import OriginalCarousel from "./components/original-carousel";
import NewsOverview from "./components/scripts/news-overview";
import NewsTeaser from "./components/scripts/news-teaser";
import CookieBanner from "./components/cookie-banner.vue";
import TagManager from "./components/tag-manager.vue";
import OiForm from "./components/oi-form.vue";
import OiVideo from "./components/oi-video.vue";
import EventBus from "./helpers/eventbus";
import BrowserStorage from "./helpers/browser-storage";

import { router } from "./global";

// Keep it! If you build the app with NODE_ENV = "production", it won't log.
taggr().warning("Your application is running in development mode.");

Vue.use(VueRouter);
Vue.use(Vuelidate);

const vm = new Vue({
    router,
    data() {
        return {
            isMenuOpen: false,
            isCurtainBarOpen: false,
            isTeamDetailOpen: false,
            displayAllAwards: false,
            displayAllCustomers: false,
            imageLink: "",
            text: "",
            mail: "",
            phone: "",
            facebookLink: "",
            instagramLink: "",
            linkedInLink: "",
            identifier: "",
            showVideo: false,
        };
    },
    mounted() {
        this.calcIncludeScrollButtonSectionHeight();

        window.addEventListener("resize", debounce(this.calcIncludeScrollButtonSectionHeight.bind(this), 300));
        EventBus.$on('cookieConsent', () => {
            this.showVideo = false;
            if (BrowserStorage.getBooleanCookie('hasThirdPartyConsent')) {
                this.showVideo = true;
            }
        });
    },
    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        openMenu() {
            this.isMenuOpen = true;
        },
        closeMenu() {
            this.isMenuOpen = false;
        },
        toggleAllAwards() {
            this.displayAllAwards = !this.displayAllAwards;
        },
        toggleAllCustomers() {
            this.displayAllCustomers = !this.displayAllCustomers;
        },
        showCurtainBar() {
            this.isCurtainBarOpen = true;
        },
        hideCurtainBar() {
            this.isCurtainBarOpen = false;
        },
        updateTeamDetail(
            identifier: string,
            imageLink: string,
            text: string,
            mail: string,
            phone: string,
            facebookLink: string,
            instagramLink: string,
            linkedInLink: string,
        ) {
            this.imageLink = imageLink;
            this.text = text;
            this.mail = mail;
            this.phone = phone;
            this.facebookLink = facebookLink;
            this.instagramLink = instagramLink;
            this.linkedInLink = linkedInLink;
            this.isTeamDetailOpen = true;
            this.identifier = identifier;

            setTimeout(() => {
                const teamDetail = document.querySelector("#o-team-detail") as HTMLElement;
                const teamInformation = document.querySelector("#" + identifier + " .information") as HTMLElement;

                this.showAllTeamInformation();

                if (teamInformation) {
                    teamInformation.classList.add("hide");
                }

                if (teamDetail) {
                    scrollIntoViewport()(teamDetail);
                }
            }, 100);
        },
        scrollToTop() {
            scrollIntoViewport()(document.body);
        },
        scrollToMainContent(isBranding: false) {
            const mainContent = isBranding ? document.querySelector("#mainContent > .o-section.include-scroll-button + .o-section")
            :
            document.querySelector("#mainContent > .o-section:first-of-type");

            if (mainContent) {
                const style = window.getComputedStyle(mainContent);
                scrollIntoViewport(parseInt(style.marginTop || "0", 10))(
                    mainContent as HTMLElement,
                );
            }
        },
        showAllTeamInformation() {
            const allTeamInformation = document.querySelectorAll(".o-team .information") as NodeListOf<HTMLElement>;

            for (const info of allTeamInformation) {
                info.classList.remove("hide");
            }
        },
        closeTeamDetail() {
            this.isTeamDetailOpen = false;

            setTimeout(() => {
                const teamMember = document.querySelector("#" + this.identifier) as HTMLElement;
                this.showAllTeamInformation();
                if (teamMember) {
                    scrollIntoViewport()(teamMember);
                }
            }, 100);
        },
        openCookieBanner() {
            EventBus.$emit("openCookieBanner", {});
        },
        calcIncludeScrollButtonSectionHeight() {
            const section = document.querySelector(".o-section.include-scroll-button") as HTMLElement;
            const sectionTitle = document.querySelector(".o-section.o-section-title ") as HTMLElement;

            if (section && sectionTitle) {
                const sectionStyle = window.getComputedStyle(section);
                const sectionTitleStyle = window.getComputedStyle(sectionTitle);
                const sectionMarginBottom = (sectionStyle.marginTop || "0");
                const sectionTitleMarginTop = (sectionTitleStyle.marginTop || "0");
                const sectionTitleMarginBottom = (sectionTitleStyle.marginTop || "0");

                const height = sectionTitle.clientHeight + parseInt(sectionTitleMarginTop, 10) + parseInt(sectionTitleMarginBottom, 10);
                let heightStyling = "calc(100vh - (" + height + "px + 20vh) + " + (parseInt(sectionMarginBottom, 10) - 11) + "px)";


                if (window.innerWidth < 769) {
                    heightStyling = "auto";
                } else {
                    section.style.marginBottom = "11px";
                }

                section.style.height = heightStyling;
            }
        },
    },
    computed: {
        windowWidth() {
            return window.innerWidth;
        },
    },
});

Vue.component("cookie-banner", CookieBanner);
Vue.component("tag-manager", TagManager);
Vue.component("fixie-border", Fixie);
Vue.component("lazy-media", LazyMedia);
Vue.component("reference-overview", ReferenceOverview);
Vue.component("team-detail", TeamDetail);
Vue.component("multi-carousel", Carousel);
Vue.component("original-carousel", OriginalCarousel);
Vue.component("google-map", GoogleMap);
Vue.component("news-overview", NewsOverview);
Vue.component("news-teaser", NewsTeaser);
Vue.component("oi-form", OiForm);
Vue.component("oi-video", OiVideo);

vm.$mount("#view");



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/main.ts